import { OPACITY_HEX_VALUES } from '../constants/hexAlphaValues';

export const applyOpacityToHex = (hexColor, opacity) => {
    const alpha = OPACITY_HEX_VALUES[opacity];

    return hexColor + alpha;
};
